import { OfferCreateValidatorRequestWrite } from 'shared/api/client/codegen.api';

export enum ECreateOfferStages {
	CREATE = 'create',
	GENERATE = 'generate',
	LOADING = 'loading',
	PREVIEW = 'preview',
}

export enum EOfferTypes {
	PRIVATE = 'private',
	PUBLIC = 'public',
}

export enum EOfferStages {
	OVERVIEW = 'overview',
	PROPOSALS = 'proposals',
	ACTIVE = 'active',
	UNDER_REVIEW = 'under_review',
	COMPLETED = 'completed',
}

export type TOfferStage = EOfferStages;

export type TOfferForm  = Omit<OfferCreateValidatorRequestWrite, 'attachments' | 'type'>
